import { createContext } from "react";

const AppContext = createContext({
    locationName: 'منوی سفارشات',
    setLocationName: () => {},
    currencyType: 'ریال',
    setCurrencyType: () => {},
    companyId: '',
    setCompanyId: () => {},
});

export default AppContext;
